/* 🤖 this file was generated by script */
export const wiconTrashUndo = {
  name: 'trash_undo',
  data: `<svg viewBox="0 0 20 21"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.5 5.75L14 17.25H6l-.34-2.59m9.84-8.91h1m-1 0h-2m-10 0h3m0 0l1-2h5l1 2m-7 0h7"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M10.49 14.19c0-5.8-4.18-4.07-7.15-4.07m0 0l2.29-2.28m-2.29 2.28l2.29 2.3"/></svg>`,
};
